import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import AdminShell from '../layout/AdminShell';
import Card from '../ui/Card';
import Button from '../ui/Button';
import Badge from '../ui/Badge';
import AvatarCircle from '../ui/AvatarCircle';
import EmptyState from '../ui/EmptyState';
import AddAgentModal from '../settings/AddAgentModal';
import { PlusIcon, UserIcon } from '../ui/icons';

// Redesign of newadmin/Agents.js — lists state.organisation.users.
const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

const roleTone = (role) => (role === 'agent' ? 'success' : 'accent');

const AgentsPage = () => {
    const agents = useSelector((s) => s.organisation.users);
    const [addOpen, setAddOpen] = useState(false);

    const list = agents || [];

    return (
        <AdminShell title="Agents">
            <AddAgentModal open={addOpen} onClose={() => setAddOpen(false)} />

            <Card
                title="Agents"
                subtitle="Manage your agents"
                actions={
                    <Button onClick={() => setAddOpen(true)}>
                        <PlusIcon className="h-4 w-4" />
                        Add Agent
                    </Button>
                }
                bodyClassName="p-0"
            >
                {list.length === 0 ? (
                    <EmptyState
                        icon={<UserIcon className="h-6 w-6" />}
                        title="No agents yet"
                        subtitle="Agents in your organisation will appear here."
                    />
                ) : (
                    <ul className="divide-y divide-[#F0F1F5]">
                        {list.map((agent) => (
                            <li key={agent.id} className="flex items-center gap-3 px-4 sm:px-6 py-4">
                                <AvatarCircle name={agent.name} size="md" />
                                <div className="min-w-0 flex-1">
                                    <p className="text-sm font-bold text-[#1F2937] truncate">{agent.name}</p>
                                    <p className="text-xs text-[#6B7280] truncate">{agent.email}</p>
                                </div>
                                <Badge tone={roleTone(agent.role)}>{capitalizeFirstLetter(agent.role || '')}</Badge>
                            </li>
                        ))}
                    </ul>
                )}
            </Card>
        </AdminShell>
    );
};

export default AgentsPage;
